import store from '../store';

const { Howl } = require('howler');

const sounds = {
  message: new Howl({
    src: ['./sounds/message.mp3'],
  }),
};

export default {
  play(soundName) {
    if (store.getters['layout/getSoundIsMuted']) return;

    sounds[soundName].play();
  },
};
